import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';

export default styled.div`
  font-weight: 500;
  text-align: center;
  width: 1.5rem;
`;
